import { required, TextInput } from "react-admin";
import { IdType } from "utils/constants";
import { PersonIdTypes } from "utils/choices";
import { useWatch } from "react-hook-form";
import { noCyrillic, onlyDigits, pidValidator } from "utils/validations";
import { settings } from "app";
import { tenants } from "utils/tenants";

const PersonIdInput = ({ isKSK, isForeigner, isDisable, userData }) => {
  const currentType = useWatch({ name: "userInfo.personIdType" });
  const isMgu = settings.tenant === tenants.MGU;

  const validators = [required("Задължително"), noCyrillic()];

  if (currentType === IdType.EGN || currentType === IdType.PNF) {
    validators.push(onlyDigits);
  }

  if (currentType === IdType.PID) {
    validators.push(pidValidator());
  }

  return (
    <TextInput
      source="userInfo.personId"
      label={
        isMgu ? PersonIdTypes.find(t => t.id === currentType)?.name || "ЕГН/ЛНЧ/ПИД" : !isForeigner ? "ЕГН" : "ЛНЧ/ПИД"
      }
      disabled={isKSK && !isForeigner}
      defaultValue={userData?.userInfo?.personId || ""}
      validate={validators}
      readOnly={isDisable}
      fullWidth
    />
  );
};

export default PersonIdInput;
